<template>
  <div>
    <b-form @submit.stop.prevent="handleAddress">
      <div v-if="originalString">
        <h5 v-translate>Original Data</h5>
        <p>
          {{ originalString }}
          <a
            href="#"
            @click.prevent="copyToClipboard(originalString, 'text')"
            class="text-secondary"
            :title="$gettext('Copy to Clipboard')"
            ><font-awesome-icon :icon="['far', 'copy']" size="1x"
          /></a>
          <b-button
            size="sm"
            @click.stop="openMapOn(originalString)"
            style="padding: 0.05rem 0.25rem; vertical-align: bottom"
            :title="$gettext('Quick view address map on new window')"
          >
            <font-awesome-icon
              :icon="['fa', 'map-marked-alt']"
              size="2x"
              style="font-size: 10px; vertical-align: middle"
            />
          </b-button>
        </p>
        <div v-if="shipping.fields_revision_data[this.originalParam].postalCode">
          <h6 v-translate>Original Data (Extra)</h6>
          <p v-translate="{ data: shipping.fields_revision_data[this.originalParam].postalCode }">
            Zip Code: <strong>%{data}</strong>
          </p>
        </div>
      </div>

      <div
        v-if="
          shipping.fields_revision_data &&
          shipping.fields_revision_data[type] &&
          typeof shipping.fields_revision_data[type] === 'object'
        "
      >
        <div v-if="editType === 'radio'">
          <b-form-radio-group id="radio-group-2" v-model="shipping[placeIdParam]" @input="address = null">
            <b-form-radio
              :value="item"
              v-for="(item, index) in shipping.fields_revision_data[type]"
              :key="index"
              :selected="item.place_id === shipping[placeIdParam]"
            >
              {{ item.main_text }}, {{ item.secondary_text }}
              <b-button
                size="sm"
                @click.stop="openMapOn(item.main_text + ', ' + item.secondary_text)"
                style="padding: 0.05rem 0.25rem; vertical-align: bottom"
                :title="$gettext('Quick view address map on new window')"
              >
                <font-awesome-icon
                  :icon="['fa', 'map-marked-alt']"
                  size="2x"
                  style="font-size: 10px; vertical-align: middle"
                />
              </b-button>
            </b-form-radio>
          </b-form-radio-group>
          <b-button
            size="sm"
            style="padding: 0.25rem 1rem"
            variant="primary"
            @click.prevent="editType = 'autocomplete'"
            class="mt-3"
            v-translate
          >
            Change to Autocomplete
          </b-button>

          <div v-if="$frontConfig.ai?.checkAddress?.enabled || (env === 'admin-local' && 1 === 1)" class="my-3">
            <b-button
              size="sm"
              @click="aiCheckAddress"
              :disabled="aiWorking || !originalString || originalString.toLowerCase().includes(' sn,')"
            >
              <translate>Try AI ✨</translate>
              <b-spinner small v-if="aiWorking" />
            </b-button>
            <b-form-checkbox v-model="aiConfig.pinit.enabled" switch v-if="allowPinit" class="mt-1">
              <translate>Use Pinit</translate>
            </b-form-checkbox>
            <!-- Single Address Processing Steps Indicator -->
            <div v-if="processingStep === 'single'" class="mt-3 mb-3">
              <b-progress :value="singleProgress" :max="100" show-progress></b-progress>
              <small class="text-muted mt-1 d-block">{{ singleProgressText }}</small>
            </div>
            <div v-if="aiAddress?.clean">
              <span v-translate="{ data: aiAddress.clean }">Best AI try: <strong>%{data}</strong></span>
              <b-button size="sm" v-if="aiAddress?.clean !== 'ERROR'" @click="sendToAc">
                <font-awesome-icon icon="arrow-right" />
                <font-awesome-icon icon="search" />
              </b-button>
            </div>
          </div>
          <div v-if="aiAddress?.place" class="mb-3">
            ✨ <strong>{{ aiAddress.gplaces }}</strong
            ><br />
            <small
              >Raw:
              <strong>{{
                JSON.parse(aiAddress.place.raw).google?.results[0].formatted_address ||
                JSON.parse(aiAddress.place.raw).results[0].formatted_address
              }}</strong></small
            >
            <b-badge :variant="getConfidenceBadgeVariant(aiAddress.confidence)">
              {{ aiAddress.confidence }}% [{{ aiAddress.engine || '' }}]
            </b-badge>
            <b-button
              size="sm"
              @click.stop="
                openMapOnCoords(
                  aiAddress.place.lat,
                  aiAddress.place.lng,
                  19,
                  JSON.parse(aiAddress.place.raw).google?.results[0].formatted_address ||
                    JSON.parse(aiAddress.place.raw).results[0].formatted_address.replaceAll(' ', '+')
                )
              "
              style="padding: 0.05rem 0.25rem; vertical-align: bottom"
              :title="$gettext('Quick view address map on new window')"
            >
              <font-awesome-icon
                :icon="['fa', 'map-marked-alt']"
                size="2x"
                style="font-size: 10px; vertical-align: middle"
              />
            </b-button>
            <br />
            <b-button
              size="sm"
              @click="aiAccepted(); checkThePlace(aiAddress.place)"
              :variant="(aiStatus === true ? '' : 'outline-') + 'success'"
            >
              <font-awesome-icon icon="thumbs-up" />
            </b-button>
            <b-button size="sm" @click="aiRejected()" :variant="(aiStatus === false ? '' : 'outline-') + 'danger'">
              <font-awesome-icon icon="thumbs-down" />
            </b-button>
          </div>
          <div v-if="aiAddress?.clean === 'ERROR' || aiAddress?.gplaces === 'FAIL'" class="mb-3">
            <b-alert variant="danger" show>
              <div v-translate="{ error: aiAddress.error || $gettext('No valid Google Place.') }">
                %{error} Please go on manually.
              </div>
            </b-alert>
          </div>

          <p v-if="address">
            {{ address }}
            <b-button variant="danger" size="sm" @click="addressAcInput = ''; address = null" class="py-0 px-1"
              >✕</b-button
            >
            <b-button
              size="sm"
              @click.stop="openMapOn(address)"
              style="padding: 0.05rem 0.25rem; vertical-align: bottom"
              :title="$gettext('Quick view address map on new window')"
            >
              <font-awesome-icon
                :icon="['fa', 'map-marked-alt']"
                size="2x"
                style="font-size: 10px; vertical-align: middle"
              />
            </b-button>
          </p>
        </div>
        <div v-else>
          <div v-if="$frontConfig.ai?.checkAddress?.enabled || (env === 'admin-local' && 1 === 1)" class="my-3">
            <b-button
              size="sm"
              @click="aiCheckAddress"
              :disabled="aiWorking || !originalString || originalString.toLowerCase().includes(' sn,')"
            >
              <translate>Try AI ✨</translate>
              <b-spinner small v-if="aiWorking" />
            </b-button>
            <b-form-checkbox v-model="aiConfig.pinit.enabled" switch v-if="allowPinit" class="mt-1">
              <translate>Use Pinit</translate>
            </b-form-checkbox>
            <!-- Single Address Processing Steps Indicator -->
            <div v-if="processingStep === 'single'" class="mt-3 mb-3">
              <b-progress :value="singleProgress" :max="100" show-progress></b-progress>
              <small class="text-muted mt-1 d-block">{{ singleProgressText }}</small>
            </div>
            <div v-if="aiAddress?.clean">
              <span v-translate="{ data: aiAddress.clean }">Best AI try: <strong>%{data}</strong></span>
              <b-button size="sm" v-if="aiAddress?.clean !== 'ERROR'" @click="sendToAc">
                <font-awesome-icon icon="arrow-right" />
                <font-awesome-icon icon="search" />
              </b-button>
            </div>
          </div>
          <div v-if="aiAddress?.place" class="mb-3">
            ✨ <strong>{{ aiAddress.gplaces }}</strong
            ><br />
            <small
              >Raw:
              <strong>{{
                JSON.parse(aiAddress.place.raw).google?.results[0].formatted_address ||
                JSON.parse(aiAddress.place.raw).results[0].formatted_address
              }}</strong></small
            >
            <b-badge :variant="getConfidenceBadgeVariant(aiAddress.confidence)">
              {{ aiAddress.confidence }}% [{{ aiAddress.engine || '' }}]
            </b-badge>
            <b-button
              size="sm"
              @click.stop="
                openMapOnCoords(
                  aiAddress.place.lat,
                  aiAddress.place.lng,
                  19,
                  JSON.parse(aiAddress.place.raw).google?.results[0].formatted_address ||
                    JSON.parse(aiAddress.place.raw).results[0].formatted_address.replaceAll(' ', '+')
                )
              "
              style="padding: 0.05rem 0.25rem; vertical-align: bottom"
              :title="$gettext('Quick view address map on new window')"
            >
              <font-awesome-icon
                :icon="['fa', 'map-marked-alt']"
                size="2x"
                style="font-size: 10px; vertical-align: middle"
              />
            </b-button>
            <br />
            <b-button
              size="sm"
              @click="aiAccepted(); checkThePlace(aiAddress.place)"
              :variant="(aiStatus === true ? '' : 'outline-') + 'success'"
            >
              <font-awesome-icon icon="thumbs-up" />
            </b-button>
            <b-button size="sm" @click="aiRejected()" :variant="(aiStatus === false ? '' : 'outline-') + 'danger'">
              <font-awesome-icon icon="thumbs-down" />
            </b-button>
          </div>
          <div v-if="aiAddress?.clean === 'ERROR' || aiAddress?.gplaces === 'FAIL'" class="mb-3">
            <b-alert variant="danger" show>
              <div v-translate="{ error: aiAddress.error || $gettext('No valid Google Place.') }">
                %{error} Please go on manually.
              </div>
            </b-alert>
          </div>

          <address-autocomplete ref="address" v-if="!address" @selected="checkThePlace" :minCharacter="4" />
          <p v-else>
            {{ address }}
            <b-button variant="danger" size="sm" @click="addressAcInput = ''; address = null" class="py-0 px-1"
              >✕</b-button
            >
            <b-button size="sm" @click.stop="openMapOn(address)" style="padding: 0.05rem 0.25rem; vertical-align: bottom"
              :title="$gettext('Quick view address map on new window')"
            >
              <font-awesome-icon
                :icon="['fa', 'map-marked-alt']"
                size="2x"
                style="font-size: 10px; vertical-align: middle"
              />
            </b-button>
          </p>
          <b-button size="sm" style="padding: 0.25rem 1rem" variant="primary" @click.prevent="editType = 'radio'"
            class="mt-3"
          >
            <translate>Change to Multiple</translate>
          </b-button>
        </div>
      </div>
      <div
        v-if="
          shipping.fields_revision_data &&
          shipping.fields_revision_data[type] &&
          typeof shipping.fields_revision_data[type] === 'string'
        "
      >
        <p>
          <span v-translate="{ data: shipping.fields_revision_data[type] }"
            >Current failed string: <strong>%{data}</strong></span
          >
          <a
            href="#"
            @click.prevent="copyToClipboard(shipping.fields_revision_data[type], 'text')"
            class="text-secondary"
            :title="$gettext('Copy to Clipboard')"
            ><font-awesome-icon :icon="['far', 'copy']" size="1x"
          /></a>
          <b-button
            size="sm"
            @click.stop="openMapOn(shipping.fields_revision_data[type])"
            style="padding: 0.05rem 0.25rem; vertical-align: bottom"
            :title="$gettext('Quick view address map on new window')"
          >
            <font-awesome-icon
              :icon="['fa', 'map-marked-alt']"
              size="2x"
              style="font-size: 10px; vertical-align: middle"
            />
          </b-button>
        </p>

        <!-- CL HACK for Adidas -->
        <p v-if="externalDataChecked">
          <span v-translate="{ data: externalDataChecked || $gettext('Not detected') }"
            >Autodetected commune: <strong>%{data}</strong></span
          >
          <span v-if="externalDataSuggestion">
            <br />
            <span v-translate="{ data: externalDataSuggestion }">Suggested text: <strong>%{data}</strong></span>
            <a
              href="#"
              @click.prevent="copyToClipboard(externalDataSuggestion, 'text')"
              class="text-secondary"
              :title="$gettext('Copy to Clipboard')"
              ><font-awesome-icon :icon="['far', 'copy']" size="1x"
            /></a>
          </span>
        </p>
        <!-- /CL HACK for Adidas -->

        <div v-if="$frontConfig.ai?.checkAddress?.enabled || (env === 'admin-local' && 1 === 1)" class="my-3">
          <b-button
            size="sm"
            @click="aiCheckAddress"
            :disabled="aiWorking || !originalString || originalString.toLowerCase().includes(' sn,')"
          >
            <translate>Try AI ✨</translate>
            <b-spinner small v-if="aiWorking" />
          </b-button>
          <b-form-checkbox v-model="aiConfig.pinit.enabled" switch v-if="allowPinit" class="mt-1">
            <translate>Use Pinit</translate>
          </b-form-checkbox>
          <!-- Single Address Processing Steps Indicator -->
          <div v-if="processingStep === 'single'" class="mt-3 mb-3">
            <b-progress :value="singleProgress" :max="100" show-progress></b-progress>
            <small class="text-muted mt-1 d-block">{{ singleProgressText }}</small>
          </div>
          <div v-if="aiAddress?.clean">
            <span v-translate="{ data: aiAddress.clean }">Best AI try: <strong>%{data}</strong></span>
            <b-button size="sm" v-if="aiAddress?.clean !== 'ERROR'" @click="sendToAc">
              <font-awesome-icon icon="arrow-right" />
              <font-awesome-icon icon="search" />
            </b-button>
          </div>
        </div>
        <b-card v-if="aiAddress?.place" class="mb-3">
          ✨ <strong>{{ aiAddress.gplaces }}</strong
          ><br />
          <small
            >Raw:
            <strong>{{
              JSON.parse(aiAddress.place.raw).google?.results[0].formatted_address ||
              JSON.parse(aiAddress.place.raw).results[0].formatted_address
            }}</strong></small
          >
          <b-badge :variant="getConfidenceBadgeVariant(aiAddress.confidence)">
            {{ aiAddress.confidence }}% [{{ aiAddress.engine || '' }}]
          </b-badge>
          <b-button
            size="sm"
            @click.stop="
              openMapOnCoords(
                aiAddress.place.lat,
                aiAddress.place.lng,
                19,
                JSON.parse(aiAddress.place.raw).google?.results[0].formatted_address ||
                  JSON.parse(aiAddress.place.raw).results[0].formatted_address.replaceAll(' ', '+')
              )
            "
            style="padding: 0.05rem 0.25rem; vertical-align: bottom"
            :title="$gettext('Quick view address map on new window')"
          >
            <font-awesome-icon
              :icon="['fa', 'map-marked-alt']"
              size="2x"
              style="font-size: 10px; vertical-align: middle"
            />
          </b-button>
          <br />
          <b-button
            size="sm"
            @click="aiAccepted(); checkThePlace(aiAddress.place)"
            :variant="(aiStatus === true ? '' : 'outline-') + 'success'"
          >
            <font-awesome-icon icon="thumbs-up" />
          </b-button>
          <b-button size="sm" @click="aiRejected()" :variant="(aiStatus === false ? '' : 'outline-') + 'danger'">
            <font-awesome-icon icon="thumbs-down" />
          </b-button>
        </b-card>
        <div v-if="aiAddress?.clean === 'ERROR' || aiAddress?.gplaces === 'FAIL'" class="mb-3">
          <b-alert variant="danger" show>
            <div v-translate="{ error: aiAddress.error || $gettext('No valid Google Place.') }">
              %{error} Please go on manually.
            </div>
          </b-alert>
        </div>

        <address-autocomplete
          ref="address"
          v-if="!shipping[placeIdParam]"
          @selected="checkThePlace"
          :minCharacter="4"
        />
        <p v-else>
          {{ address }}
          <b-button variant="danger" size="sm" @click="resetSelectedAddress()" class="py-0 px-1">✕</b-button>
          <b-button
            size="sm"
            @click.stop="openMapOn(address)"
            style="padding: 0.05rem 0.25rem; vertical-align: bottom"
            :title="$gettext('Quick view address map on new window')"
          >
            <font-awesome-icon
              :icon="['fa', 'map-marked-alt']"
              size="2x"
              style="font-size: 10px; vertical-align: middle"
            />
          </b-button>
        </p>
      </div>
      <div class="mt-3">
        <label for="extra" v-translate>Floor, door, etc.</label>
        <div class="input-group">
          <b-form-input id="extra" v-model="shipping[extraParam]" class="col-12 form-control" />
        </div>
      </div>
      <div v-if="shipping[type + '_meta']" class="mt-3">
        <dl>
          <dt v-if="type === 'from'" v-translate>Instructions on origin</dt>
          <dt v-else v-translate>Instructions on destination</dt>
          <dd>{{ shipping[type + '_meta'] }}</dd>
        </dl>
      </div>
      <div class="text-right form-group col-12 form-actions">
        <b-button type="submit" variant="primary" size="lg" v-translate>Confirm Address</b-button>
        <b-button variant="outline-primary" size="lg" @click.prevent="emitCancel" v-translate>Cancel</b-button>
      </div>
    </b-form>
    <b-modal
      size="lg"
      id="modalPickPlace"
      ref="modalPickPlace"
      hide-footer
      hide-header
      @hide="$refs.pickPlaceMap.pickPlace(0, 0)"
    >
      <place-picker
        ref="pickPlaceMap"
        hasReference
        @cancel="closeModalPickPlace"
        @placePicked="setPlacePicked"
        centerMap
        fit-always
        :zoom="17"
      />
    </b-modal>
    <!-- <pre>{{ shipping.meta }}</pre> -->
  </div>
</template>

<script>
import AddressMixins from '@/mixins/address.mixin.js'
import AddressProcessingMixin from '@/mixins/address-processing.mixin.js'
import AddressAutocomplete from '@/components/autocompletes/AddressAutocomplete'
import PlacePicker from '@/components/PlacePicker'
import Papa from 'papaparse'

export default {
  name: 'FixAddressesForm',
  components: {
    AddressAutocomplete,
    PlacePicker
  },
  props: {
    theShipping: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'to'
    }
  },
  data() {
    return {
      env: process.env.ENV_FLAG,
      shipping: {},
      address: null,
      placeIdParam: '',
      metaParam: '',
      extraParam: '',
      originalParam: '',
      valid: false,
      editType: 'radio',
      externalData: [],
      externalDataChecked: '',
      externalDataSuggestion: '',
      aiWorking: false,
      aiAddress: null,
      aiStatus: null,
      allowPinit: false
    }
  },
  computed: {
    originalString() {
      const data = this.shipping.fields_revision_data?.[this.originalParam]
      if (!data) return ''

      // Return pre-formatted address if it exists
      if (data.address) return data.address

      // Join street and number with a space
      const streetFull = [data.street, data.number].filter(Boolean).join(' ')

      // Safely find country name
      const countryName = window.countries?.find(c => c.iso_code === this.shipping.to_country_iso_code)?.name

      // Combine all parts with commas, filtering out empty values
      return [streetFull, data.city, data.postalCode, data.state, countryName].filter(Boolean).join(', ')
    }
  },
  mixins: [AddressMixins, AddressProcessingMixin],
  created() {
    if (this.type === 'to') {
      this.placeIdParam = 'to_place_id'
      this.metaParam = 'to_meta'
      this.extraParam = 'to_extra'
      this.originalParam = 'to_original'
    } else {
      this.placeIdParam = 'from_place_id'
      this.metaParam = 'from_meta'
      this.extraParam = 'from_extra'
      this.originalParam = 'from_original'
    }
    this.shipping = { ...this.theShipping }
  },
  mounted() {
    // CL HACK for Adidas
    if (
      (this.shipping.to_country_iso_code === 'CL' || this.shipping.from_country_iso_code === 'CL') &&
      (typeof this.shipping.fields_revision_data.to === 'string' ||
        this.shipping.fields_revision_data.to instanceof String)
    ) {
      let matches = this.shipping.fields_revision_data.to.match(/(\d{7})/)
      if (matches) {
        let match = matches[0]
        Papa.parse('/static/files/comunas-chile.csv', {
          download: true,
          complete: results => {
            this.externalData = Object.fromEntries(results.data.map(x => [x[1], x[0]]))
            this.externalDataChecked = this.externalData[match.slice(0, 3)]
            this.externalDataSuggestion = this.shipping.fields_revision_data.to.replace(
              /(\d{7})/,
              this.externalDataChecked + ', '
            )
          }
        })
      }
    }
    this.allowPinit = this.aiConfig.pinit.enabled
    this.aiConfig.pinit.enabled = false
  },
  methods: {
    async checkThePlace(place) {
      await this.checkPlace(place)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.address = this.theCheckedAddress.formatted_address
          this.shipping[this.placeIdParam] = this.theCheckedAddress.id
          this.valid = true
          this.theCheckedAddress = {}
        } else if (this.theCheckedAddress.validAddress === false) {
          this.$refs.modalPickPlace.show()
          setTimeout(
            function () {
              this.$refs.pickPlaceMap.center = {
                lat: this.theCheckedAddress.lat,
                lng: this.theCheckedAddress.lng
              }
              this.$refs.pickPlaceMap.reference = this.$refs.address.searchQuery
              this.$refs.pickPlaceMap.styles = 'height: 500px;'
            }.bind(this),
            100
          )
        }
      })
    },
    setPlaceId(placeId) {
      this.shipping[this.placeIdParam] = placeId
      this.valid = true
    },
    setPlacePicked(place) {
      this.address = place.formatted_address
      this.setPlaceId(place.id)
      this.shipping[this.metaParam] = place.reference
        ? place.reference + ' - ' + (this.shipping[this.metaParam] || '')
        : this.shipping[this.metaParam]
      this.$refs.modalPickPlace.hide()
    },
    closeModalPickPlace() {
      this.$refs.modalPickPlace.hide()
    },
    async handleAddress() {
      if (
        !this.valid &&
        this.shipping.fields_revision_data &&
        typeof this.shipping.fields_revision_data[this.type] !== 'string'
      ) {
        let placeToCheck = this.shipping[this.placeIdParam]
        await this.checkThePlace(placeToCheck)
      }
      this.$nextTick(() => {
        if (this.shipping[this.placeIdParam] && this.valid) {
          let payload = {
            [this.placeIdParam]: this.shipping[this.placeIdParam],
            [this.metaParam]: this.shipping[this.metaParam],
            [this.extraParam]: this.shipping[this.extraParam]
          }
          if (this.aiAddress && this.shipping.meta?.ai?.addresses?.[this.type]?.accepted) {
            payload[this.metaParam] = (this.shipping[this.metaParam] || '') + '\nOriginal: ' + this.originalString
          }
          if (this.aiAddress && this.shipping.meta?.ai) {
            payload.meta = this.shipping.meta
          }
          this.$http.patch(this.$appConfig.api.baseUrl + 'shippings/' + this.shipping.id, payload).then(response => {
            this.$emit('shippingupdated', this.shipping)
            this.$emit('success', true)
            this.theCheckedAddress = {}
            this.shipping = {}
            this.valid = false
          })
        }
      })
    },
    resetSelectedAddress() {
      this.addressAcInput = ''
      this.shipping[this.placeIdParam] = null
      this.aiStatus = null
      delete this.shipping.meta?.ai?.addresses?.[this.type]
    },
    emitCancel() {
      this.$emit('cancel')
    },
    async aiCheckAddress() {
      console.log('AI Config: ', this.aiConfig)

      this.aiWorking = true
      this.aiAddress = {}
      this.processingStep = 'single'
      this.aiAddress = await this.processSingleAddressWithProgress(this.externalDataSuggestion || this.originalString)

      if (this.aiAddress.place?.is_valid) {
        this.aiAddress.place.google_place_id = this.aiAddress.place.place_id
        this.aiAddress.place.place_id = this.aiAddress.place.id
      }
      console.log('Final aiAddress: ', this.aiAddress)
      // Completar progreso
      this.singleProgress = 100
      this.singleProgressText = 'Processing completed successfully!'
      this.aiWorking = false
    },
    aiAccepted() {
      this.aiStatus = true
      this.address = this.aiAddress.place.formatted_address
      this.shipping.meta = {
        ...this.shipping.meta,
        ai: {
          addresses: {
            [this.type]: {
              accepted: true,
              aiAddress: this.aiAddress,
              telemetry: this.telemetry.usageMetadata
            }
          }
        }
      }
    },
    aiRejected() {
      this.aiStatus = false
      this.shipping.meta = {
        ...this.shipping.meta,
        ai: {
          addresses: {
            [this.type]: {
              accepted: false,
              aiAddress: this.aiAddress,
              telemetry: this.telemetry.usageMetadata
            }
          }
        }
      }
    },
    sendToAc() {
      this.editType = 'autocomplete'
      this.$nextTick(() => {
        this.$refs.address.$refs.suggestions.query = this.aiAddress.clean
      })
    },
    openMapOnCoords(lat, lng, z, place = null) {
      if (!place || window.country === 'CO') {
        window.open(`https://www.google.com/maps/place/@${lat},${lng},${z}z`)
      } else {
        window.open(`https://www.google.com/maps/place/${place}/@${lat},${lng},${z}z`)
      }
    }
  }
}
</script>
